<template>
  <ValidationProvider v-slot="{ errors }" :name="`'${label}'`" :rules="rules" :vid="vid">
    <v-combobox
        :item-value="itemValue"
        :item-text="itemText"
        :items="filterItems"
        :value="current"
        :error-messages="errors"
        :label="label"
        :readonly="readonly"
        :clearable="clearable && !readonly"
        :prepend-icon="prependIcon"
        :search-input.sync="search"
        return-object
        eager
        :dense="dense"
        @input="input"
        @change="change">
      <template v-slot:prepend-inner>
        <v-icon
            v-if="required"
            small
            left
            :color="requiredColor">
          *
        </v-icon>
      </template>
    </v-combobox>
  </ValidationProvider>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { DICTIONARIES } from '@/constants/store.js'

  import { DICTIONARY_TYPES } from '@/constants/business'
  export default {
    props: {
      itemValue: {
        type: String,
        default: 'incotermId'
      },
      itemText: {
        type: String,
        default: 'name'
      },
      value: {
        type: [String, Number],
        default: null
      },
      onlyWithBasises: {
        type: Boolean,
        default: false
      },
      refresh: {
        type: Boolean,
        default: false
      },
      rules: [String, Object],
      prependIcon: {
        type: String,
        default: ''
      },
      requiredColor: {
        type: String,
        default: 'requiredfield'
      },
      label: {
        type: String,
        default: ''
      },
      readonly: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: false
      },
      dense: {
        type: Boolean,
        default: false
      },
      vid: {
        type: String,
        default: null
      }
    },
    data () {
      return {
        isLoading: false,
        search: ''
      }
    },
    computed: {
      ...mapState(DICTIONARIES.NAMESPACE, {
        incoterms: state => (state[DICTIONARY_TYPES.INCOTERMS] || [])
      }),
      required () {
        if (!this.rules) {
          return false
        }
        return (this.rules.hasOwnProperty('required') && this.rules.required) ||
          (!this.rules.hasOwnProperty('required') &&
            !!this.rules.length &&
            this.rules.includes('required'))
      },
      current () {
        const vm = this
        return vm.incoterms.find(u => u[this.itemValue] === vm.value)
      },
      filterItems () {
        let items = this.incoterms
        if (this.search && (!this.current || this.search !== this.current[this.itemText])) {
          items = items.filter(p => p[this.itemText].includes(this.search))
        }
        if (this.current && this.current[this.itemValue]) {
          items = items.filter(p => this.current[this.itemValue] !== p[this.itemValue])
        }
        if (this.onlyWithBasises) {
          items = items.filter(p => p.hasBasises)
        }
        return items
      }
    },
    watch: {

      refresh: {
        immediate: true,
        handler (newVal, oldVal) {
          if (newVal && newVal !== oldVal) {
            this.getIncoterms()
          }
        }
      }
    },
    created: async function () {
      if (!this.incoterms.length) {
        this.getIncoterms()
      }
    },
    methods: {
      ...mapActions(DICTIONARIES.NAMESPACE, {
        getBusinessDictionaryItemsAction: DICTIONARIES.ACTIONS.GET_BUSINESS_DICTIONARY_ITEMS
      }),
      getIncoterms: async function () {
        try {
          this.isLoading = true
          await this.getBusinessDictionaryItemsAction({
            dictionaryType: DICTIONARY_TYPES.INCOTERMS
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      input: function (item) {
        this.$emit('input', item ? item[this.itemValue] : null)
      },
      change: function (item) {
        if ((item && item[this.itemValue] !== this.value) ||
          (!item && this.value)) {
          this.$emit('change', item || null)
        }
      }
    }
  }
</script>
